import { useQuery } from '@apollo/client/react';
import { PendingPlanUpgradeDocument, type PendingPlanUpgradeQuery } from '@/graphql';

export type PendingPlanUpgrade = NonNullable<PendingPlanUpgradeQuery['pendingPlanUpgrade']>;

/** The credit upgrade awaiting its invoice; read live from Stripe, for billing admins only. */
export function usePendingPlanUpgrade({ skip = false }: { skip?: boolean } = {}) {
  const { data } = useQuery(PendingPlanUpgradeDocument, { fetchPolicy: 'cache-and-network', skip });
  return data?.pendingPlanUpgrade ?? null;
}
